export default __webpack_public_path__ + "static/media/metamask.30289624.png";